import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

let headers = ''

function headersSet() {
  const headersQ = window.localStorage.getItem('Headers')
  headers = JSON.parse(headersQ)
}

export const addDriver = createAsyncThunk('appDriver/Create', async (Driver) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Driver/Create', Driver, { headers }, { mode: 'cors' })

  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const getDocumentTypeList = createAsyncThunk('appDriver/getDocumentTypeList', async (OwnerType) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentTypeList', OwnerType, { mode: 'cors' })

  return response.data
})

export const getDocument = createAsyncThunk('appDriver/getDocument', async (Doc) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocument', Doc, { mode: 'cors' })

  return response.data
})

export const addDocument = createAsyncThunk('appDriver/CreateDocument', async (formData) => {
  let flag = 0

  const response = await axios.post('https://api.zasway.com:8443/Common/Create', formData, { mode: 'cors' })
  if (response.data.code === 200) { flag = 1 }

  return {
    response,
    isSaved: flag
  }
})


export const resetFlag = createAsyncThunk('appDriver/ResetFlag', () => {

  return { isSaved: 0 }
})

export const deleteDocument = createAsyncThunk('appDriver/DeleteDocument', async (id) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/DeleteDocument', id, { mode: 'cors' })
  return response
})
export const EditDocument = createAsyncThunk('appDriver/UpdateDocument', async (formData) => {

  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/UpdateDocument', formData, { mode: 'cors' })

  if (response.data.code === 200) { flag = 1 }

  return {
    response,
    isSaved: flag
  }
})

export const getDriverImage = createAsyncThunk('appDriver/GetDriverImage', async (driver) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDriverImage', driver, { mode: 'cors' })
  return response.data
})
export const UploadImage = createAsyncThunk('appDriver/UploadImage', async (formData) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/UploadImageDriver', formData, { mode: 'cors' })

  return response
})

export const getDriverType = createAsyncThunk('appDriver/getDriverType', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverTypeList')
  return response.data
})
export const getDriverStatus = createAsyncThunk('appDriver/getDriverStatus', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverStatusList')
  return response.data
})
export const GetDefaultPaymentModel = createAsyncThunk('appDriver/GetDefaultPaymentModel', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDefaultPaymentModelList', params, { mode: 'cors' })

  return response.data
})
export const getSubCompany = createAsyncThunk('appDriver/getSubCompany', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetSubCompanyList')
  return response.data
})

export const getNationality = createAsyncThunk('appDriver/getNationality', async () => {

  const response = await axios.get('https://api.zasway.com:8443/Common/GetNationalityList')
  return response.data
})

export const getAllData = createAsyncThunk('appDriver/GetTableSummary', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummary', GetDriver, { mode: 'cors' })

  return response.data
})

export const GetDriverPassword = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverPassword', params, { mode: 'cors' })

  return response.data
})

export const GetVehicle = createAsyncThunk('appDriver/GetVehicleList', async (GetVehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleList', GetVehicle, { mode: 'cors' })

  return response.data
})

export const GetDriverTag = createAsyncThunk('appDriver/GetDriverTagList', async (GetVehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverTagList', GetVehicle, { mode: 'cors' })

  return response.data
})

export const getDriverStats = createAsyncThunk('appDriver/GetDriverStatistics', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverStatistics', GetDriver, { mode: 'cors' })

  return response.data
})
export const GetDriverDocumentSummary = createAsyncThunk('appDriver/GetDriverDocumentSummary', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverDocument', GetDriver, { mode: 'cors' })

  return response.data
})

export const GetDocumentDetails = createAsyncThunk('appDriver/GetDocumentDetails', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverDocumentDetails', GetDriver, { mode: 'cors' })

  return response.data
})
export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, { mode: 'cors' })

  return response.data
})
export const GetDocumentDetailsByID = createAsyncThunk('appDriver/GetDocumentDetailsByID', async (document) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentDetailByID', document, { mode: 'cors' })

  return response.data
})
export const getData = createAsyncThunk('appDriver/getData', async (params) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummary', params, { headers }, { mode: 'cors' })

  if (response.data.code === undefined) {
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const getData1 = createAsyncThunk('appDriver/getData', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummary', params, { mode: 'cors' })

  return response.data
})
export const getDriver = createAsyncThunk('appDriver/getDriver', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})
export const EditDriver = createAsyncThunk('appDriver/Update', async (Driver) => {
  // headersSet()

  const response = await axios.post('https://api.zasway.com:8443/Driver/Update', Driver, { mode: 'cors' })

  return response
  //  
  // if (response.data.code === undefined || response.data.code === 200) {
  //   return {
  //     data : response
  //   }
  // } else {
  //   return {
  //     data : response.data.code
  //   }
  // }
})
export const deleteDriver = createAsyncThunk('appDriver/Delete', async (id, { dispatch, getState }) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Driver/Delete', id, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().driver.params))

  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data
    }
  }
})

export const updateDriverActiveStatus = createAsyncThunk('appDriver/UpdateActiveStatus', async (params, { dispatch, getState }) => {
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverActiveStatus', params, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().driver.params))
  return response.data
})

export const addUser = createAsyncThunk('appDriver/addUser', async (user, { dispatch, getState }) => {

  await axios.post('https://api.zasway.com:8443/User/CreateUser', user, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})
// export const addUser = createAsyncThunk('appDriver/addUser', async (user, { dispatch, getState }) => {
//   await axios.post('https://api.zasway.com:8443/apps/users/add-user', user)
//   await dispatch(getData(getState().users.params))
//   await dispatch(getAllData())
//   return user
// })
export const editPassword = createAsyncThunk('profileSettings/editPassword', async (Password) => {

  const response = await axios.post('https://api.zasway.com:8443/ProfileSettings/UpdatePassword', Password, { mode: 'cors' })

  return response
})
export const GetTopDriver = createAsyncThunk('Driver/GetTopDriver', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTopDriver', GetDriver, { mode: 'cors' })

  return response.data
})
export const getDriverBookingCount = createAsyncThunk('Driver/GetDriverBookingCount', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverBookingCount', GetDriver, { mode: 'cors' })

  return response.data
})
export const deleteUser = createAsyncThunk('appDriver/deleteUser', async (id, { dispatch, getState }) => {

  await axios.post('https://api.zasway.com:8443/User/DeleteUser', { id }, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})
export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://api.zasway.com:8443/api/users/user', { id })
  return response.data.user
})
export const getProducts = createAsyncThunk('appUsers/getProducts', async params => {
  const response = await axios.get('/apps/ecommerce/products', { params })
  return { params, data: response.data }
})
export const CloseModel = createAsyncThunk('/appDriver/CloseModel', (IsClosed) => {

  return { data: IsClosed }
})
export const ResetCloseModel = createAsyncThunk('/appDriver/ResetCloseModel', () => {

  return { data: false }
})
export const getPassengerImage = createAsyncThunk('appDriver/GetPassengerImage', async (driver) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerImage', driver, { mode: 'cors' })
  // const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerImage', driver, { mode: 'cors' })

  return response.data
})

export const getDriverWeekDays = createAsyncThunk('appDriver/getDriverWeekDays', async (GetWDDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverWeekDays', GetWDDetails, { mode: 'cors' })
  return {
    data: response.data
  }
})

export const getDriverBookingTrends = createAsyncThunk('appDriver/getDriverBookingTrends', async (GetBTDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverBookingTrends', GetBTDetails, { mode: 'cors' })

  return {
    data: response.data
  }
})

export const getAllBookingTrends = createAsyncThunk('appDriver/getAllBookingTrends', async (GetBTDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetAllBookingTrends', GetBTDetails, { mode: 'cors' })

  return {
    data: response.data
  }
})

export const getTableSummaryDriverSignUpRequest = createAsyncThunk('appDriver/getTableSummaryDriverSignUpRequest', async (Obj) => {
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverSignUpRequest', Obj, { mode: 'cors' })
  return response.data
})

export const driverSignUpRequestApproval = createAsyncThunk('appDriver/DriverSignUpRequestApproval', async (DriverObj) => {
  const response = await axios.post('https://api.zasway.com:8443/Driver/DriverSignUpRequestApproval', DriverObj, { mode: 'cors' })
  return response.data
})

export const checkEmailExists = createAsyncThunk('appDriver/checkEmailExists', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Driver/CheckEmailAlreadyExists', params, { mode: 'cors' })
  return response.data
})

export const appDriverSlice = createSlice({
  name: 'appDriver',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument: [],
    DriverWeekDaysData: [],
    DriverBookingTrends: [],
    AllBookingTrends: [],
    IsSaved: 0,
    IsClosed: false,
    approvalList: []
  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getDriverWeekDays.fulfilled, (state, action) => {
        state.DriverWeekDaysData = action.payload.data
      })

      .addCase(getDriverBookingTrends.fulfilled, (state, action) => {

        state.DriverBookingTrends = action.payload.data
      })

      .addCase(getAllBookingTrends.fulfilled, (state, action) => {

        state.AllBookingTrends = action.payload.data
      })

      .addCase(getData.fulfilled, (state, action) => {

        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
      })
      .addCase(getDriver.fulfilled, (state, action) => {

        state.selectedUser = action.payload.allData[0]
      })
      .addCase(GetDocumentDetailsByID.fulfilled, (state, action) => {

        state.selectedDocument = action.payload
      })
      .addCase(addDocument.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(EditDocument.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(resetFlag.fulfilled, (state, action) => {

        state.IsSaved = action.payload.isSaved
      })
      .addCase(CloseModel.fulfilled, (state, action) => {

        state.IsClosed = action.payload.data
      })

      .addCase(ResetCloseModel.fulfilled, (state, action) => {

        state.IsClosed = action.payload.data
      })
      .addCase(getTableSummaryDriverSignUpRequest.fulfilled, (state, action) => {
        state.approvalList = action.payload
      })
  }
})

export default appDriverSlice.reducer
